<template>
  <div class="vz-news-card">
    <nuxt-link
      :to="link"
      class="vz-news-card__image"
      @click="onClick"
    >
      <NuxtImg
        :src="src"
        :class="{ active: active }"
        loading="lazy"
      />
      <div class="vz-news-card__more">
        <div>
          Подробнее
        </div>
      </div>
    </nuxt-link>
    <div class="vz-news-card__date">{{ date }}</div>
    <div class="vz-news-card__title">{{ item.title }}</div>
    <div  class="vz-news-card__description">{{ item.announce }}</div>
  </div>
</template>

<script setup lang="ts">
import {getFullDate} from '~/common/date';
import {PropType} from 'vue';
import {EventRecord} from '~/types/components/personal/actions';
import {BASE_URL_HTTPS} from '~/composables/useVzFetch';

const props = defineProps({
  item: {
    type: Object as PropType<EventRecord>,
    default: () => ({})
  },
})

const active = ref(false)

const date = computed(() => {
  return getFullDate(props.item.date)
})

const link = computed(() => {
  const tag = props.item?.is_action ? 'actions' : 'news'
  return `/${tag}/${props.item.href}/`
})

const src = computed(() => {
  return props.item.imageUrls?.main || (BASE_URL_HTTPS + props.item.img)
})

function onClick() {
  active.value = true
}
</script>

<style scoped lang="scss">
.vz-news-card {
  $animation-duration: 0.3s;

  &__image, img {
    display: block;
    width: 100%;
    height: 260px;
    object-fit: cover;
    transition-duration: $animation-duration;
  }

  &__image {
    position: relative;
    cursor: pointer;

    &:hover {
      img {
        filter: blur(3px);
      }
      .vz-news-card__more {
        background-color: rgba(105, 105, 105, 0.4);
        > div {
          color: $white;
          border-color: $white;
        }
      }
    }
  }

  &__more {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: $animation-duration;

    > div {
      transition-duration: $animation-duration;
      color: transparent;
      border: 1px solid transparent;
      border-radius: 4px;
      padding: 12px 64px;
    }
  }

  &__date {
    font-size: $fs-14;
    color: $font-lower;
    font-weight: 500;
    margin-top: 10px;
  }

  &__title {
    font-size: $fs-20;
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 5px;
  }
}
</style>

<style scoped>
.vz-news-card__image img.active {
  view-transition-name: selected-news-card;
  contain: layout;
}
</style>
